import React, { Component } from 'react';
import { firebaseRef } from './firebase.js';
import Indicator from './indicator';
class Login extends Component {
  constructor(props){
    super(props);
    this.state = {
      email: '',
      password: '',
      errorMassege: '',
      loading: '',
    };
  this.handleSubmit = this.handleSubmit.bind(this);
  this.handleChangeUsername = this.handleChangeUsername.bind(this);
  this.handleChangePassword = this.handleChangePassword.bind(this);
  this._userguide = this._userguide.bind(this);
  //this.regex = "/[>/<':;{~`}!#%$)(_=+&^|]|[0-9]/g";
  }

  handleChangeUsername(event) {
    this.setState({email: event.target.value});
  }

handleChangePassword(event) {
      this.setState({password: event.target.value});
    }

handleSubmit(event){
  var that=this;
  this.setState({
    loading: <Indicator />,
  });
  if ((this.state.email || this.state.password) === '') {
      this.setState({
         errorMassege: 'Please fill in all the required fileds',
         loading: '',
       });
      return false;
  }
  firebaseRef.auth().signInWithEmailAndPassword(this.state.email, this.state.password).then(function(){
    var authUser = firebaseRef.auth().currentUser;
    that.props.history.push({
      pathname: '/newuser',
       state: { doctor: authUser.uid }
});
  })
  .catch(function(error) {
  // Handle Errors here.
  var errorCode = error.code;
  var massage = ""
  if (errorCode === "auth/wrong-password") {
    massage = "Wrong Password or Email";
  }
  if (errorCode === "auth/invalid-email") {
    massage = "Invalid Email";
  }
  if (errorCode === "auth/user-not-found") {
    massage = "Wrong Password or Email";
  }
  that.setState({
    errorMassege: massage,
    loading: '',
  });
});
}

_userguide(){
  this.props.history.push("/userguide");
}

  render() {
    return (
      <div id="main-container" align="center">
      <div id="header">
        <h2 className="header-title">Chirosystem</h2>
        <div className="header-links">
       <button type="button" onClick={this._userguide} className="logout-button">Guide</button>
       </div>
      </div>
      <form className="login-signup-container">
      <div>
      <div>
        <input type="email" className="text-inputs" placeholder="Email" value={this.state.email} onChange={this.handleChangeUsername} align="center"/>
        </div>
        <div>
        <input type="password" className="text-inputs" placeholder="Password" value={this.state.password} onChange={this.handleChangePassword} />
        </div>
        <input type="button" className="button-forms" value="Log in" onClick={this.handleSubmit} />
          <div>
            <p style={{color: "red"}}>{this.state.errorMassege}</p>
            <div>{this.state.loading}</div>
          </div>
          </div>
      </form>
      </div>
    );
  }
}

export default Login;



// WEBPACK FOOTER //
// ./src/routes/Login.js